/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivityRespondedActivityReplyInner
 */
export interface ActivityRespondedActivityReplyInner {
    /**
     * 
     * @type {string}
     * @memberof ActivityRespondedActivityReplyInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityRespondedActivityReplyInner
     */
    respondDate: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActivityRespondedActivityReplyInner
     */
    imagePaths: Array<string>;
}

/**
 * Check if a given object implements the ActivityRespondedActivityReplyInner interface.
 */
export function instanceOfActivityRespondedActivityReplyInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "respondDate" in value;
    isInstance = isInstance && "imagePaths" in value;

    return isInstance;
}

export function ActivityRespondedActivityReplyInnerFromJSON(json: any): ActivityRespondedActivityReplyInner {
    return ActivityRespondedActivityReplyInnerFromJSONTyped(json, false);
}

export function ActivityRespondedActivityReplyInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityRespondedActivityReplyInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'respondDate': json['respondDate'],
        'imagePaths': json['imagePaths'],
    };
}

export function ActivityRespondedActivityReplyInnerToJSON(value?: ActivityRespondedActivityReplyInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'respondDate': value.respondDate,
        'imagePaths': value.imagePaths,
    };
}

